module.exports = __webpack_public_path__ + "img/byqicon.ba51bfbb.png";